import { RoleName } from 'types/graphql';

// Mapping from RoleName to a human readable label.
export const ROLE_LABEL_BY_VALUE: Record<RoleName, string> = {
  [RoleName.Member]: 'Member',
  [RoleName.ContentCreator]: 'Content Creator',
  [RoleName.Owner]: 'Owner',
};

const roleEntries = Object.entries(ROLE_LABEL_BY_VALUE) as [RoleName, string][];

// List of available roles together with a human readable label.
export const ROLES = roleEntries.map(([value, label]) => ({ value, label }));
